import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Collapse from '@mui/material/Collapse';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import type { ApolloError } from '@apollo/client';

import { EnhancedAlert, SaveButton } from 'components/shared';

// Local Typings
interface Props {
  addError: ApolloError | undefined;
  isAdmin: boolean;
  isCurrentUserMarkedAsFraud: boolean | undefined;
  isLoading: boolean;
  isOpen: boolean;
  onDialogClose: () => void;
  onUpdateFraudStatus: () => void;
  removeError: ApolloError | undefined;
  userFullName: string;
}

const MarkAsFraudDialog = ({
  addError,
  isAdmin,
  isCurrentUserMarkedAsFraud,
  isLoading,
  isOpen,
  onDialogClose,
  onUpdateFraudStatus,
  removeError,
  userFullName,
}: Props): JSX.Element => {
  const toggleFraudVerb = `${isCurrentUserMarkedAsFraud ? 'Remove' : 'Add'}`;

  return (
    <Dialog
      maxWidth="xs"
      onClose={onDialogClose}
      open={isOpen}
    >
      <DialogTitle>{toggleFraudVerb} Fraud Status</DialogTitle>

      <DialogContent>
        <DialogContentText gutterBottom>
          {`Do you want to ${toggleFraudVerb.toLocaleLowerCase()} the fraud flag for ${userFullName}?`}
        </DialogContentText>

        <DialogContentText>
          {isCurrentUserMarkedAsFraud
            ? `This will remove the fraud flag and allow the user to the view this ${isAdmin ? 'admin portal' : 'organization'}.`
            : `This will prevent the user from accessing this ${isAdmin ? 'admin portal' : 'organization'}.`}
        </DialogContentText>

        <Collapse in={Boolean(addError || removeError)}>
          <Box marginTop={2}>
            <EnhancedAlert severity="error">
              {addError ? addError?.message : removeError?.message}
            </EnhancedAlert>
          </Box>
        </Collapse>
      </DialogContent>

      <DialogActions>
        <Button
          color="primary"
          onClick={onDialogClose}
        >
          Cancel
        </Button>
        <SaveButton
          color="primary"
          isSaving={isLoading}
          onClick={onUpdateFraudStatus}
          variant="contained"
        >
          {`Yes, ${toggleFraudVerb} Flag`}
        </SaveButton>
      </DialogActions>
    </Dialog>
  );
};

export default MarkAsFraudDialog;
